import { ReactNode } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'

interface Props {
  children: ReactNode
  onClose: () => void
  open: boolean
  title?: ReactNode
}

const AlertDialog = ({ children, onClose, open, title }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-describedby="title-dialog-description"
      {...(title ? { 'aria-labelledby': 'alert-dialog-title' } : {})}
    >
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText id="title-dialog-description">
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AlertDialog
